import { CaseState } from 'app/area/case/types-store';
import { EnabledChildEntityOperations } from 'app/infrastructure/ui/types-uischema';

export const enabledChildEntityOperations = (state: CaseState, uiEngineProps: any): 
  { enabledChildEntityOperations: EnabledChildEntityOperations } => {
  
  if (uiEngineProps.enabledChildEntityOperations) {
    // If operations are already configured from outside, leave as is.
    return {
      enabledChildEntityOperations: uiEngineProps.readOnly ?
        { add: false, remove: false, copy: false } :
        uiEngineProps.enabledChildEntityOperations
    };
  }

  const { componentDescriptor: { properties = {} } = {} } = uiEngineProps;
  const disableCopyOperation = properties && properties.disableCopyOperation;

  return { 
    enabledChildEntityOperations: 
      uiEngineProps.readOnly ? 
        { add: false, remove: false, copy: false } : 
        { 
          add: true, 
          remove: true, 
          copy: !disableCopyOperation
        }
  };

};
